import styledTheme from 'common/theme';
import { themeColors } from 'themes';
import { blueAngledStripesGradient } from './gradient';

const baseColors = {
  
  idle: 'rgba(138, 136, 134, 1)',
  
  cleaning: '#0076CC',
  maintenance: 'rgba(230, 108, 55, 1)',
  'wait time': 'rgba(182, 44, 16, 1)',
  production: themeColors.green2,
  oee: 'rgba(0, 118, 204, 1)',
  sterilization: '#009EB3',
  sterilisation: '#009EB3',
  Sterilisation: '#009EB3',
  sip: themeColors.cyan,
  'SIP': themeColors.cyan,
  performance: 'rgba(125, 150, 195, 1)',
  availability: 'rgba(131, 93, 208, 1)',
  quality: 'rgba(0, 158, 179, 1)',
  'production downtime': themeColors.error200,
  "machine utilization": '#0E00B3',
  "utilization": '#0E00B3',
  "machine availability": '#750985',
  AVD: '#405C85',
  Dry: styledTheme.colors.darkRed,
  Foil: '#009EB3',
  General: '#C83D95',
  ready: themeColors.ready,
  Infeed: '#407E85',
  NVD: '#7EBCC3',
  Outfeed: '#8378C3',
  Product: '#9E5F31',
  Filling: '#9E5F31',
  Screw: '#E66C37',
  'Approved': themeColors.green2,
  'Rejected': themeColors.error200,
  'N2 flush': styledTheme.colors.Telemetry1700,
  'internal': '#0076CC',
  'cip': themeColors.primaryBlue5,
  'CIP': themeColors.primaryBlue5,
  'external': '#009EB3',
  'internal downtime': styledTheme.colors.Telemetry1400,
  'external downtime': styledTheme.colors.Telemetry1700,
  Doors: styledTheme.colors.Telemetry2300,
  "Main CIP": styledTheme.colors.Telemetry300,
  "main cip": styledTheme.colors.Telemetry300,
  "mainCip": styledTheme.colors.Telemetry300,
  Standby: styledTheme.colors.Telemetry2100,
  "standby": styledTheme.colors.Telemetry2100,
  "Rinse": styledTheme.colors.Telemetry100,
  "rinse": styledTheme.colors.Telemetry100,
  Machine: styledTheme.colors.Telemetry1700,
  "Intermediate CIP": styledTheme.colors.Telemetry500,
  "intermediate cip": styledTheme.colors.Telemetry500,
  machine: 'rgba(230, 108, 55, 1)',
  caution: themeColors.caution200,
  preparation: themeColors.preparation,
  unsterile: themeColors.unsterile,
  "pms 10 cip": themeColors.primaryBlue5,
  "pms 5 ready": themeColors.ready,
  "pms 6 unsterile": themeColors.unsterile,
  "pms 11 sip": themeColors.cyan,
  "pms 12 preparation": themeColors.preparation,
  "pms 1 production": themeColors.green2,
  "pms 4 standby": styledTheme.colors.Telemetry2100,
  "pms 3 maintenance": themeColors.serviceInfo,
};

const laneAlarmsColors = {
  foil: 'rgba(0, 118, 204, 1)',
  cap: 'rgba(0, 118, 204, 1)',
  filling: 'rgba(131, 93, 208, 1)',
  'screw capping': '#FFADC1',
  'infeed module': 'rgba(138, 136, 134, 1)',
  'outfeed module': baseColors.Outfeed,
  sealing: 'rgba(230, 108, 55, 1)',
  'Outfeed module': baseColors.Outfeed,
  'Infeed module': baseColors.Infeed,
  "intermediate cip":styledTheme.colors.Telemetry500
}; 


export const colors: Record<string, string> = {
  ...laneAlarmsColors,
  ...baseColors,
  'Performance': baseColors.performance,
  'Availability': baseColors.availability,
  'Quality': baseColors.quality,
  'oee': baseColors.oee,
  Mainten: baseColors.maintenance,
  'Wait time': baseColors['wait time'],
  'waitTime': baseColors['wait time'],
  'waittime': baseColors['wait time'],
  'wait_time': baseColors['wait time'],
  'production uptime': themeColors.green2,
  Foil: laneAlarmsColors.foil,
  Filling: laneAlarmsColors.filling,
  'avd process': 'rgba(252, 214, 65, 1)',
  Sealing: laneAlarmsColors.sealing,
  Production: themeColors.green2,
  Idle: baseColors.idle,
  actualDurationTitle: styledTheme.colors.black,
  actualDurationSubText: styledTheme.colors.gray800,
  actualDurationExtraText: '#b62c10',
  uptime: themeColors.green2,
  downtime: themeColors.error200,
  'bottle count': '#0076CC',
  'Loaded but not detected': styledTheme.colors.jbtBlue,
  'Loaded but not filled': styledTheme.colors.Telemetry200,
  'Filling not complete': styledTheme.colors.orange1,
  "vertical65": '#BA4E00',
  vertical85: '#B30000',
  'horizontal65': '#BA4E00',
  'horizontal85': '#B30000',
  // 'max bottles': `repeating-linear-gradient(
  //   -45deg,
  //   ${ styledTheme.colors.jbtBlue},
  //   ${ styledTheme.colors.jbtBlue} 2px,
  //   ${ styledTheme.colors.neg} 3px,
  //   ${ styledTheme.colors.neg} 5px,
  //   ${ styledTheme.colors.jbtBlue} 6px
  // )`,
  'max bottles': blueAngledStripesGradient,
  'approved bottles': styledTheme.colors.jbtBlue,
  //'approvedBottleCount': themeColors.green2,
  rejectedBottleCount: styledTheme.colors.error200,
};

export const changeoverTableColors = {
  positiveValue: styledTheme.colors.success200,
  negativeValue: styledTheme.colors.error200
};

export const actualDurationColors = {
  positiveValue: styledTheme.colors.success200,
  negativeValue: styledTheme.colors.error200
};

